// extracted by mini-css-extract-plugin
export default {"schedule":"schedule_schedule__Rpcfm","addSchedule":"schedule_addSchedule__cRWqN","img":"schedule_img__JR-ov","desc":"schedule_desc__ikS6C"};